import { priceFormatFinancial } from "helpers/prices";
import { LoanOfferResponse } from "../interfaces/loanOffer.interface";

export const isValidRequest = (
  offerResult: LoanOfferResponse,
  downPayment: number
): boolean =>
  offerResult.offers[0].downPaymentAmount === downPayment;

export const downPaymentMessage = (
  offerResult: LoanOfferResponse,
  downPayment: number
): { label: string, value: string } => {
  if (offerResult.offers[0].downPaymentAmount > downPayment) {
    return {
      label: "Enganche insuficiente",
      value: `${priceFormatFinancial(downPayment, 0)} MXN`
    };
  }

  return {
    label: "Enganche muy alto",
    value: `${priceFormatFinancial(downPayment, 0)} MXN`
  };
};
